var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.967 3.63382C15.6929 4.33652 16.9705 5.9388 17.1876 7.89276L17.5095 10.7901C17.6561 12.1091 18.0349 13.3919 18.6284 14.5789L19.9476 17.2174C20.5294 18.381 19.6833 19.7501 18.3824 19.7501H14.6469C14.3204 20.9043 13.2592 21.7499 12.0004 21.7499C10.7417 21.7499 9.68048 20.9043 9.35398 19.7501H5.61847C4.31755 19.7501 3.47143 18.381 4.05322 17.2174L5.37248 14.5789C5.96601 13.3919 6.34481 12.1091 6.49137 10.7901L6.8133 7.89276C7.0304 5.9388 8.30798 4.33652 10.0339 3.63382C10.2059 2.70413 11.0209 2 12.0004 2C12.9799 2 13.795 2.70413 13.967 3.63382ZM5.61847 18.2501C5.43262 18.2501 5.31175 18.0545 5.39486 17.8882L6.71412 15.2497C7.38678 13.9044 7.81609 12.4507 7.98219 10.9558L8.30412 8.05841C8.51339 6.17495 10.1054 4.75005 12.0004 4.75005C13.8955 4.75005 15.4875 6.17496 15.6967 8.05841L16.0187 10.9558C16.1848 12.4507 16.6141 13.9044 17.2867 15.2497L18.606 17.8882C18.6891 18.0545 18.5682 18.2501 18.3824 18.2501H5.61847ZM11.0004 19.7501C11.2285 20.0536 11.5915 20.2499 12.0004 20.2499C12.4093 20.2499 12.7724 20.0536 13.0004 19.7501H11.0004Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlert);
export default __webpack_public_path__ + "static/media/icn_alert.706002188064dd634b96809eacd15bdb.svg";
export { ForwardRef as ReactComponent };